import * as types from '../actions/actionTypes';
import initialState from './initialState';

        
        
export default function insigniaReducer(state= initialState.insignia, action){
    let newState;
	switch(action.type){
         case types.LOAD_INSIGNIA_LIST_SUCCESS:		
            action.insignia.filtroActivo=state.filtroActivo;
            action.insignia.filtroActual=state.filtroActual;
            action.insignia.showActivos=state.showActivos;
			 action.insignia.paginaActual=action.insignia.pageable.pageNumber;
			 action.insignia.registrosPorPagina=action.insignia.size;
            
            return action.insignia;

        case types.BORRAR_INSIGNIA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(insignia => insignia.id !== action.insignia.id)];          
			return newState;    
            
        case types.ACTIVAR_INSIGNIA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(insignia => insignia.id !== action.insignia.id)];          
			 return newState;
            
        case types.SET_FILTRO_INSIGNIA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}